import React from 'react';
import '../template-file-css/document-file-template.css';


export const CBS_InitialPsychiatricAssessment = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='CBS_InitialPsychiatricAssessment' className='file-pdf-document'>
            <div className='file-template'>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Marital Status:</span>
                            <input type="radio" id="rbMaritalStatus_1" name="rbMaritalStatus" className='add-only' value="Single" /> Single &nbsp;
                            <input type="radio" id="rbMaritalStatus_2" name="rbMaritalStatus" className='add-only' value="Divorced" /> Divorced &nbsp;
                            <input type="radio" id="rbMaritalStatus_3" name="rbMaritalStatus" className='add-only' value="Married" /> Married &nbsp;
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Legal Status:</span>
                            <input type="text" id="txtLegalStatus" name="txtLegalStatus" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Referral Source:</span>
                            <input type="text" id="txtReferralSource" name="txtReferralSource" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Referral Diagnosis:</span>
                            <input type="text" id="txtReferralDiagnosis" name="txtReferralDiagnosis" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Chief Complaint: </span>
                            <input type="text" id="txtChiefComplaint" name="txtChiefComplaint" className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>History of Present Illness:</span>
                    <textarea id="txtIllness" name="txtIllness" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Past Psychiatric History:</span>
                    <textarea id="txtPsychiatricHistory" name="txtPsychiatricHistory" className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Past Medical History: </span>
                    <textarea id="txtMedicalHistory" name="txtMedicalHistory" className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Medications: </span>
                    <textarea id="txtMedications" name="txtMedications" className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Allergies: </span>
                    <textarea id="txtAllergies" name="txtAllergies" className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Family History:</span>
                    <textarea id="txtFamilyHistory" name="txtFamilyHistory" className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Substance History: </span>
                    <textarea id="txtSubstanceHistory" name="txtSubstanceHistory" className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Legal History: </span>
                    <textarea id="txtLegalHistory" name="txtLegalHistory" className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Developmental/Psychosocial History:</span>
                    <textarea id="txtDevelopmental" name="txtDevelopmental" className='add-only'></textarea>
                </p>

                <h3>Mental Status Exam:</h3>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Appearance: </span>
                            <input type="text" id="txtAppearance" name="txtAppearance" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Behavior/Attitude:</span>
                            <input type="text" id="txtBehavior" name="txtBehavior" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Thought Process:</span>
                            <input type="text" id="txtThoughtProcess" name="txtThoughtProcess" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Thought Content:</span>
                            <input type="text" id="txtThoughtContent" name="txtThoughtContent" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Perceptions:</span>
                            <input type="text" id="txtPerceptions" name="txtPerceptions" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Speech:</span>
                            <input type="text" id="txtSpeech" name="txtSpeech" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Motor:</span>
                            <input type="text" id="txtMotor" name="txtMotor" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Mood:</span>
                            <input type="text" id="txtMood" name="txtMood" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Affect:</span>
                            <input type="text" id="txtAffect" name="txtAffect" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Insight/Judgement:</span>
                            <input type="text" id="txtInsight" name="txtInsight" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Orientation/Memory/Cognition: </span>
                            <input type="text" id="txtOrientation" name="txtOrientation" className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Assessment:</span>
                    <textarea id="txtAssessment" name="txtAssessment" className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Justification for Admission: </span>
                    <textarea id="txtJustification" name="txtJustification" className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Plan:</span>
                    <textarea id="txtPlan" name="txtPlan" className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td  className="signature w-375">
                        </td>
                        <td  className="signature w-375">
                        </td>
                    </tr>
                    <tr>
                        <td className="small w-375">Signature:
                        </td>
                        <td className="small w-375">Date:
                        </td>
                    </tr>
                </table>







            </div>
        </form>

    )
}











